import {classNames, observer, React, useAsObservableSource} from '@api'
import {CatalogItemCardShape, useWhiteboardStore} from '@modules/whiteboard'
import * as css from './CatalogItemShape.css'


export const CatalogItemShapeIndicator = observer<{shape: CatalogItemCardShape}>(function CatalogItemShapeIndicator(props) {
  const {shape: {size: [width, height]}} = props,
    {selectedShapes} = useWhiteboardStore()

  return (
    <rect
      className={css.indicator}
      data-hide={selectedShapes.length > 1}
      pointerEvents='none'
      width={width}
      height={height}
      fill='none'
      stroke='tl-selectedStroke'
      strokeWidth={1}
      rx={4}
    />
  )
})


// WEBPACK FOOTER //
// ./src/modules/whiteboard/shapes/catalogItem/CatalogItemShapeIndicator.tsx